import { IEnvironment } from './interfaces';

const prefix = '';

export const environment: IEnvironment = {
    production: true,
    environment: 'WEB',
    apiServerBaseUrl: prefix,
    threeDotOneBaseUrl: prefix + '/3.1/',

    // TODO: Use valid clientId
    // clientId: 'AZAVISTA-ONSITE-CHECKIN'

    clientId: 'AZAVISTA-3.0',
    isElectron: false,
    // Gets overridden by the build system - DO NOT TOUCH
    sentryRelease: 'staging.2026-07-14-07-42-48'
};
